import { Link } from "react-router-dom";
import { ArrowRight, Check, Hourglass, Buildings } from "@phosphor-icons/react";
import { MarketingFrame } from "../components/MarketingFrame";

const TODAY = [
  "Google sign-in; every session and photo bound to its owner — no shared buckets",
  "Signed, chunked, resumable uploads that survive flaky field signal",
  "EXIF-baked naming, tags and GPS on ground and drone imagery",
  "Flight-log telemetry merge and GeoJSON export per session",
  "Cloud Sync delivery to AIImageSuite.pro with per-batch delivery webhooks and receipts",
  "Admin Ops cockpit: delivery SLOs, alerts, audit log, deep health checks",
  "Stripe-billed, self-serve ($12 / month per account)",
];

const ROADMAP = [
  "Workspaces with team roles and shared sessions",
  "SSO (SAML / OIDC) in place of per-user Google sign-in",
  "Secure ingestion routes with customer-controlled API keys per workspace",
  "SLA-backed support tiers and uptime commitments",
  "GIS vector overlays and PDF inspection reports",
  "Volume / seat pricing",
];

export default function EnterprisePage() {
  return (
    <MarketingFrame testid="enterprise-page" title="Enterprise — AIImageSuites (roadmap)"
      description="AIImageSuites for insurers, construction, marketplaces and field-service teams: what is available today and what is on the enterprise roadmap. Talk to us before you buy.">
      <article className="px-6 py-14 max-w-5xl mx-auto w-full space-y-12">
        <header className="space-y-4">
          <p className="label-mono text-neutral-500">ENTERPRISE</p>
          <h1 className="font-display font-black tracking-tighter text-4xl sm:text-6xl leading-[0.95]" data-testid="enterprise-headline">
            ONE CAPTURE WORKFLOW FOR<br /><span className="text-[#002FA7]">CATALOGUES, INSPECTIONS AND AERIAL.</span>
          </h1>
          <div className="border-2 border-dashed border-[#FF2A2A] p-4 flex items-start gap-3 max-w-3xl" data-testid="enterprise-roadmap-banner">
            <Hourglass size={20} weight="bold" className="text-[#FF2A2A] shrink-0 mt-0.5" />
            <p className="text-sm font-mono">
              <b>Honest status:</b> there is no separate enterprise tier yet. Everything in "available today" ships to every account.
              The roadmap items below are not available; we publish them so you can plan — and tell us which to build first.
            </p>
          </div>
        </header>

        <section className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="border-2 border-black p-6" data-testid="enterprise-today">
            <p className="font-display font-bold tracking-tighter text-lg">AVAILABLE TODAY</p>
            <ul className="mt-3 space-y-2 text-sm font-mono text-neutral-700">
              {TODAY.map((t, i) => <li key={i} className="flex gap-2"><Check size={16} weight="bold" className="text-green-700 shrink-0 mt-0.5" /><span>{t}</span></li>)}
            </ul>
          </div>
          <div className="border-2 border-dashed border-neutral-400 p-6 bg-[#F8F9FA]" data-testid="enterprise-roadmap">
            <p className="font-display font-bold tracking-tighter text-lg flex items-center gap-2"><Hourglass size={18} weight="bold" /> ROADMAP — NOT YET AVAILABLE</p>
            <ul className="mt-3 space-y-2 text-sm font-mono text-neutral-600">
              {ROADMAP.map((t, i) => <li key={i} className="flex gap-2"><span className="shrink-0">○</span><span>{t}</span></li>)}
            </ul>
          </div>
        </section>

        <section className="border-2 border-black p-6" data-testid="enterprise-who">
          <p className="font-display font-bold tracking-tighter text-lg flex items-center gap-2"><Buildings size={18} weight="bold" /> WHO WE ARE TALKING TO</p>
          <p className="text-sm font-mono text-neutral-700 mt-2">
            Insurance carriers and adjusters, construction and inspection firms, marketplaces and resellers with high-SKU drops,
            field-service and surveying teams. If that is you, tell us the workflow and the volume — pilots are how the roadmap gets ordered.
          </p>
          <div className="flex flex-wrap gap-3 mt-5">
            <Link to="/contact" className="btn-flat px-5 py-3 inline-flex items-center gap-2" data-testid="enterprise-contact">Talk to us <ArrowRight size={16} weight="bold" /></Link>
            <Link to="/workflows/drone" className="btn-flat-outline px-5 py-3">Drone workflow</Link>
            <Link to="/use-cases/inspection-photos" className="btn-flat-outline px-5 py-3">Inspection photos</Link>
          </div>
        </section>
      </article>
    </MarketingFrame>
  );
}
